import { render } from "./CustomerComponent.vue?vue&type=template&id=3cf0a19e&scoped=true"
const script = {}

import "./CustomerComponent.vue?vue&type=style&index=0&id=3cf0a19e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf0a19e"]])

export default __exports__